import React from 'react';

const LocationPin = () => {
    return (
        <svg width='22' height='32' viewBox='0 0 22 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M11.6244 31.5741C11.4862 31.7773 11.2519 31.8997 11.0007 31.9C10.749 31.9002 10.5141 31.7777 10.3756 31.5741C9.95242 30.9542 0 16.2922 0 10.6536C0 4.76978 4.92487 0 11 0C17.0751 0 22 4.76978 22 10.6536C22 16.2922 12.0491 30.9542 11.6244 31.5741ZM16.4503 10.8645C16.4503 13.6642 14.1069 15.9339 11.2161 15.9339C8.32534 15.9339 5.98192 13.6642 5.98192 10.8645C5.98192 8.06479 8.32534 5.79516 11.2161 5.79516C14.1069 5.79516 16.4503 8.06479 16.4503 10.8645Z'
                fill='#881155'
            />
            <mask id='mask0' maskUnits='userSpaceOnUse' x='0' y='0' width='22' height='32'>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M11.6244 31.5741C11.4862 31.7773 11.2519 31.8997 11.0007 31.9C10.749 31.9002 10.5141 31.7777 10.3756 31.5741C9.95242 30.9542 0 16.2922 0 10.6536C0 4.76978 4.92487 0 11 0C17.0751 0 22 4.76978 22 10.6536C22 16.2922 12.0491 30.9542 11.6244 31.5741ZM16.4503 10.8645C16.4503 13.6642 14.1069 15.9339 11.2161 15.9339C8.32534 15.9339 5.98192 13.6642 5.98192 10.8645C5.98192 8.06479 8.32534 5.79516 11.2161 5.79516C14.1069 5.79516 16.4503 8.06479 16.4503 10.8645Z'
                    fill='white'
                />
            </mask>
        </svg>
    );
};

export default LocationPin;
